/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from './app/hooks';
import { ChatComponent } from './features/sharedcomponents/chat/ChatComponent';
import { selectIsSearching, selectMessages } from './features/sharedcomponents/chat/chatSlice';

type ChatOrHomeRouteProps = {
  creatorMode: boolean;
  searchCategories: boolean;
};

export function ChatOrHomeRoute({ creatorMode, searchCategories }: ChatOrHomeRouteProps) {
  const location = useLocation();
  const messages = useAppSelector(selectMessages);
  const isSearching = useAppSelector(selectIsSearching);
  const currentSearch = useAppSelector((state) => state.chat.currentSearch);

  // Preserve already-loaded results for legacy /chat entries without URL parameters.
  if (!location.search && !location.hash && messages.length === 0 && !isSearching && !currentSearch) {
    return <Navigate to="/home" replace />;
  }

  return <ChatComponent creatorMode={creatorMode} searchCategories={searchCategories} />;
}
